define('v3/Pages/SchoolReport/Services/SchoolReport.Backend',[
	'jquery',
	'BackendBase'

], function ($, BackendBase) {
	function SchoolReportBackend () {
		BackendBase.call(this);
	};

	SchoolReportBackend.prototype = $.extend({}, BackendBase.prototype);
	$.extend(SchoolReportBackend.prototype, {
		getSubjectsAndClasses: function () {
			return this._getJsonApi('SchoolReport/SubjectsAndClasses');
		},
		getSchoolProgress: function (subjectCategory, semesterPeriod) {
			return this._getJsonApi('SchoolReport/WayOfWorking/' + subjectCategory + '/' + semesterPeriod);
		},
		getGrowthsOnClassesPerSubjects: function (period, subjectWithClassIdsModels) {
			var url = Settings.metricsApi;
			return this._postJsonApiWithJwtAuthorization(
				url + '/Growth/ClassGrowth?period=' + period,
				subjectWithClassIdsModels,
				{ showError: false });
		},
		getAbilitiesOnClassesOnSubject: function (period, subjectWithClassIdsModel) {
			var url = Settings.metricsApi;
			return this._postJsonApiWithJwtAuthorization(
				url + '/Ability/ClassAbilities?period=' + period,
				subjectWithClassIdsModel,
				{ showError: false });
		}
	});

	return new SchoolReportBackend();
});
